import React, {useContext} from 'react';
import './StatisticsBox.css'
import IndicatorsContext from "../../../context/AdviserContext/IndicatorsContext";
import AdviserDashboardCard from "./AdviserDashboardCard";
import ReactApexChart from "react-apexcharts";
import {
    Card,
    CardContent,
} from '@material-ui/core';
import Box from "@mui/material/Box";
import Grid from '@mui/material/Grid';
import AdviserDashboardRankingTable from "./AdviserDashboardRankingTable";

const generalPieChartOptions = (labels, title) => {
    return (
        {
            chart: {
                type: 'pie',
            },
            plotOptions: {
                pie: {
                    donut: {
                        size: '50%',
                        labels: {
                            show: true,
                            name: {
                                show: true,
                            },
                            value: {
                                show: true,
                            },
                            total: {
                                show: true,
                                label: 'Total',
                                formatter: function (w) {
                                    return w.globals.seriesTotals.reduce((a, b) => {
                                        return a + b
                                    }, 0)
                                }
                            }
                        }
                    },
                }
            },
            labels: labels,
            title: {
                text: title,
                align: 'center',
                style: {
                    color: '#3D4977',
                    fontFamily: "EncodeSansBold",
                    fontSize: '13px',
                }
            },
            dataLabels: {
                enabled: false,
            },
            legend: {
                position: 'right',
                fontSize: '10px',
            },
            //MULTIPLE COLORS VERSION
            // colors: ['#BB0D66', '#3D4977', '#3A2763', '#1F4F5A',  '#D5C6E0'],
            //MONOCHROMATIC VERSION
            colors: ['#88094a', '#a60b5a', '#b62a70', '#d95998', '#da69a2'],
        }
    )
}

const StatisticsRowPersonal = (props) => {
    const {currentMonth, adviserQuotations, adviserEmissions, adviserConversion, adviserAverageQuota} = props;
    return (
        <React.Fragment>
            <Grid item xs={3}>
                <AdviserDashboardCard title={`COTIZACIONES PERSONALES ${currentMonth}`} value={adviserQuotations}
                                      backColor={"#fff"} trend={1}/>
            </Grid>
            <Grid item xs={3}>
                <AdviserDashboardCard title={`EMISIONES PERSONALES ${currentMonth}`} value={adviserEmissions}
                                      backColor={"#fff"} trend={1}/>
            </Grid>
            <Grid item xs={3}>
                <AdviserDashboardCard title={`CONVERSIÓN PERSONAL ${currentMonth}`} value={adviserConversion}
                                      backColor={"#fff"} trend={1}/>
            </Grid>
            <Grid item xs={3}>
                <AdviserDashboardCard title={`CUOTA PROMEDIO PERSONAL ${currentMonth}`} value={adviserAverageQuota}
                                      backColor={"#fff"} trend={1}/>
            </Grid>
        </React.Fragment>
    );
}

const StatisticsRowGlobal = (props) => {
    const {currentMonth, totalQuotations, totalEmissions, totalConversion, totalAverageQuota} = props;
    return (
        <React.Fragment>
            <Grid item xs={3}>
                <AdviserDashboardCard title={`COTIZACIONES TOTALES ${currentMonth}`} value={totalQuotations}
                                      backColor={"#fff"} trend={1}/>
            </Grid>
            <Grid item xs={3}>
                <AdviserDashboardCard title={`EMISIONES TOTALES ${currentMonth}`} value={totalEmissions}
                                      backColor={"#fff"} trend={1}/>
            </Grid>
            <Grid item xs={3}>
                <AdviserDashboardCard title={`CONVERSIÓN TOTAL ${currentMonth}`} value={totalConversion}
                                      backColor={"#fff"} trend={1}/>
            </Grid>
            <Grid item xs={3}>
                <AdviserDashboardCard title={`CUOTA PROMEDIO TOTAL ${currentMonth}`} value={totalAverageQuota}
                                      backColor={"#fff"} trend={1}/>
            </Grid>
        </React.Fragment>
    );
}

const StatisticsRowGraphs = (props) => {
    const {currentMonth, emisionesAffinities, rankingEmisionesAsesores} = props;
    const topRanking = rankingEmisionesAsesores.slice(0, 4);

    let topAffinitiesNombres = [];
    let topAffinitiesEmisiones = [];
    let otrasAfinnitiesEmisiones = 0;

    emisionesAffinities.map((row, index) => {
        if (index < 4) {
            topAffinitiesNombres.push(row.Nombre)
            topAffinitiesEmisiones.push(row.Emisiones)
        } else {
            otrasAfinnitiesEmisiones += row.Emisiones;
        }
    })

    if (emisionesAffinities.length > 4) {
        topAffinitiesNombres.push("Otras")
        topAffinitiesEmisiones.push(otrasAfinnitiesEmisiones)
    }

    return (
        <React.Fragment>
            <Grid item xs={6}>
                <Card style={{width: "450px", height: "248px"}}>
                    <CardContent style={{height: "100%", padding: "4px", marginTop: "-8px"}}>
                        <AdviserDashboardRankingTable
                            ranking={topRanking}
                            title={`RANKING DE EMISIONES ${currentMonth}`}
                        />
                    </CardContent>
                </Card>
            </Grid>
            <Grid item xs={6}>
                <Card style={{width: "450px", height: "248px"}}>
                    <CardContent style={{height: "100%", padding: "4px", marginTop: "8px"}}>
                        {emisionesAffinities.length === 0
                            ? <span
                                style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    height: "100%",
                                    fontFamily: "EncodeSansRegular",
                                    fontSize: "12px"
                                }}
                            >
                                Aún no tiene emisiones en el mes de {currentMonth.charAt(0) + currentMonth.slice(1).toLowerCase()}
                            </span>
                            : <ReactApexChart
                                options={generalPieChartOptions(topAffinitiesNombres, `EMISIONES POR AFINIDAD ${currentMonth}`)}
                                series={topAffinitiesEmisiones}
                                type="donut"
                                height={230}
                                width={430}
                            />
                        }

                    </CardContent>
                </Card>
            </Grid>
        </React.Fragment>
    );
}

const StatisticsBox = () => {
    const {
        //ADVISER
        adviserQuotations,
        adviserEmissions,
        adviserConversion,
        adviserAverageQuota,
        //TOTAL
        totalQuotations,
        totalEmissions,
        totalConversion,
        totalAverageQuota,
        //GRAPHS
        affinitiesEmissionRanking,
        advisersEmissionRanking,
    } = useContext(IndicatorsContext)
    const currentMonth = new Date().toLocaleString("es-AR", {month: "long"}).toUpperCase();

    return (
        <Box sx={{flexGrow: 1}}>
            <Grid container spacing={1}>
                <Grid container item spacing={3}>
                    <StatisticsRowPersonal
                        currentMonth={currentMonth}
                        adviserQuotations={adviserQuotations}
                        adviserEmissions={adviserEmissions}
                        adviserConversion={adviserConversion}
                        adviserAverageQuota={adviserAverageQuota}
                    />
                </Grid>
                <Grid container item spacing={3}>
                    <StatisticsRowGlobal
                        currentMonth={currentMonth}
                        totalQuotations={totalQuotations}
                        totalEmissions={totalEmissions}
                        totalConversion={totalConversion}
                        totalAverageQuota={totalAverageQuota}
                    />
                </Grid>
                <Grid container item spacing={3}>
                    <StatisticsRowGraphs
                        currentMonth={currentMonth}
                        rankingEmisionesAsesores={advisersEmissionRanking}
                        emisionesAffinities={affinitiesEmissionRanking}
                    />
                </Grid>
            </Grid>
        </Box>
    )
};

export default StatisticsBox;
